// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","wrapper":"Checkbox_wrapper__f2VLQ","checked":"Checkbox_checked__XxrrH"};